import types from '../constants/claimformConstants';

const initialState = {
  data: {
    state: null,
    landlord: null,
    apartment: null,
    policy: null,
    depositAmount: null,
    claimAmount: null,
    vacantCheck: true,
    evictionCheck: true,
    keyCheck: true,
  },
  landlordArray: null,
  apartmentArray: null,
  policyArray: null,
  tenantArray: null,
  tenants: [],
  tenantsLoading: false,
  error: null,
};

const claimFormReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_DATA:
      return {
        ...state,
        data: action.payload,
      };

    case types.SET_TENANTS:
      return {
        ...state,
        tenants: action.payload,
        tenantsLoading: false,
      };
    case types.SET_TENANTS_LOADING:
      return {
        ...state,
        tenantsLoading: Boolean(action.payload),
      };
    case types.SET_LANDLORD_ARRAY:
      return {
        ...state,
        landlordArray: action.payload,
      };

    case types.SET_SELECTED_TENANT:
      return { ...state, data: { ...state.data, chosenTenant: action.payload } };
    case types.SET_APARTMENT_ARRAY:
      return {
        ...state,
        apartmentArray: action.payload,
      };
    case types.SET_RIDER_ARRAY:
      return {
        ...state,
        policyArray: action.payload,
      };
    case types.SET_CLAIMID:
      return {
        ...state,
        claimId: action.payload,
      };
    case types.SET_ERR:
      return {
        ...state,
        error: action.payload,
      };
    case types.SET_POLICY_DUPLICATED:
      return {
        ...state,
        policyDuplicated: action.payload,
      };
    case types.SET_CLAIM_RESULT:
      return {
        ...state,
        createResult: action.payload,
      };

    case types.SET_INITIATE:
      return initialState;

    case types.SET_TENANT_ARRAY:
      return {
        ...state,
        tenantArray: action.payload,
      };
    default:
      return state;
  }
};

export default claimFormReducer;
